
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Caminho 3019","d":"M5.884 0a1.843 1.843 0 00-1.791 1.867v.8H1.279A1.322 1.322 0 000 4v18.667A1.322 1.322 0 001.279 24h19.442A1.322 1.322 0 0022 22.667V4a1.322 1.322 0 00-1.279-1.333h-2.814v-.8a1.792 1.792 0 10-3.581 0v.8H7.674v-.8A1.843 1.843 0 005.884 0zm0 1.6a.245.245 0 01.256.267v3.2a.256.256 0 11-.512 0v-3.2a.245.245 0 01.256-.267zm10.233 0a.245.245 0 01.256.267v3.2a.256.256 0 11-.512 0v-3.2a.245.245 0 01.255-.267zM1.535 4.267h2.558v.8a1.792 1.792 0 103.581 0v-.8h6.651v.8a1.792 1.792 0 103.581 0v-.8h2.558v4.271H1.535zm0 5.867h18.93v12.267H1.535zm12.023 1.067a1.833 1.833 0 00-1.783 1.708l-2.43 1.75a1.711 1.711 0 00-.9-.258 1.868 1.868 0 000 3.733 1.712 1.712 0 00.9-.258l2.43 1.75a1.795 1.795 0 101.783-2.025 1.743 1.743 0 00-1.2.492l-2.15-1.55a1.631 1.631 0 000-.558l2.15-1.542a1.743 1.743 0 001.2.492 1.868 1.868 0 000-3.733zm0 1.6a.267.267 0 11-.256.267.25.25 0 01.256-.268zm-5.116 3.2a.267.267 0 11-.256.267.25.25 0 01.256-.268zm5.116 3.2a.267.267 0 11-.256.267.25.25 0 01.256-.268z","fill":"#fff"}})])
          )
        }
      }
    